import React, { useRef, useState } from 'react';
import { EMAIL_FRAME_THEME_CSS, syncEmailFrameTheme } from './emailFrameTheme';

/** Isolated display of caller-supplied HTML, including email signatures. Scripts remain disabled. */
export default function HtmlPreview({ html, title = 'HTML preview' }) {
  const frameRef = useRef(null);
  const observerRef = useRef(null);
  const [height, setHeight] = useState(120);
  const syncTheme = () => syncEmailFrameTheme(frameRef.current);
  React.useEffect(() => {
    const observer = new MutationObserver(syncTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bun-theme'] });
    return () => observer.disconnect();
  }, []);
  React.useEffect(() => () => observerRef.current?.disconnect(), []);
  return <iframe ref={frameRef} title={title} sandbox="allow-same-origin" className="w-full shrink-0 border-0 font-instrument text-bun-text" style={{ height }}
    srcDoc={`<!doctype html><html><head><style>body{margin:0;padding:14px;overflow-wrap:anywhere}img{max-width:100%}${EMAIL_FRAME_THEME_CSS}</style></head><body>${html}</body></html>`}
    onLoad={event => {
      observerRef.current?.disconnect();
      const body = event.currentTarget.contentDocument?.body;
      if (!body) return;
      syncTheme();
      const resize = () => setHeight(body.scrollHeight);
      resize();
      if (typeof ResizeObserver !== 'undefined') { observerRef.current = new ResizeObserver(resize); observerRef.current.observe(body); }
    }} />;
}
